import { useEffect, useRef, useState } from 'react';

/**
 * Zählt bei jeder Änderung weich auf den neuen Wert hoch oder herunter.
 *
 * Die Gesamtpunktzahl im Kopf springt sonst bei jedem Häkchen; das Hochzählen macht sichtbar,
 * dass die eigene Eingabe angekommen ist. Werte werden auf halbe Punkte gerundet, weil der
 * Bogen keine feineren Stufen kennt.
 */
export function useAnimatedNumber(target: number, durationMs = 320): number {
  const [value, setValue] = useState(target);
  const frame = useRef<number | null>(null);

  useEffect(() => {
    const from = value;
    if (from === target) return;

    const started = performance.now();

    const step = (now: number) => {
      const k = Math.min(1, (now - started) / durationMs);
      const eased = 1 - Math.pow(1 - k, 3);
      setValue(k >= 1 ? target : Math.round((from + (target - from) * eased) * 2) / 2);
      if (k < 1) frame.current = requestAnimationFrame(step);
    };

    frame.current = requestAnimationFrame(step);
    return () => {
      if (frame.current !== null) cancelAnimationFrame(frame.current);
    };
    // `value` bewusst nicht in der Liste: sonst startet die Animation bei jedem Zwischenschritt neu.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, durationMs]);

  return value;
}
